import { Home as HomeIcon, Building2, GraduationCap, Stethoscope, Scale, ShieldCheck, Wrench, Landmark } from "lucide-react";

export const INDUSTRIES = [
  { name: "Homeowners", icon: HomeIcon, blurb: "Honest, independent assessments to protect your largest investment." },
  { name: "Commercial Buildings", icon: Building2, blurb: "Asset-level environmental due diligence and ongoing IAQ programs." },
  { name: "Schools", icon: GraduationCap, blurb: "EPA IAQ Tools for Schools-aligned investigations and programs." },
  { name: "Healthcare", icon: Stethoscope, blurb: "Risk-tiered investigations for occupied clinical environments." },
  { name: "Attorneys", icon: Scale, blurb: "Defensible reports, expert opinions, and litigation support." },
  { name: "Insurance", icon: ShieldCheck, blurb: "Independent third-party scoping, categorization, and PRV." },
  { name: "Restoration Contractors", icon: Wrench, blurb: "Independent protocols and PRV that protect your work." },
  { name: "Government Agencies", icon: Landmark, blurb: "Scientific assessments aligned to public-sector standards." },
];

export const LOCATIONS = [
  { city: "Edinburg", region: "Headquarters" },
  { city: "McAllen", region: "Rio Grande Valley" },
  { city: "Mission", region: "Rio Grande Valley" },
  { city: "Harlingen", region: "Rio Grande Valley" },
  { city: "Brownsville", region: "Rio Grande Valley" },
  { city: "Laredo", region: "South Texas" },
  { city: "Corpus Christi", region: "Coastal Bend" },
  { city: "San Antonio", region: "South Central Texas" },
  { city: "Austin", region: "Central Texas (Service Area)" },
  { city: "Houston", region: "Gulf Coast (Service Area)" },
];
